// extracted by mini-css-extract-plugin
module.exports = {"metaItem":"_CardAttributeList_metaItem__MNUNv","metaText":"_CardAttributeList_metaText__vF96A","metaIcon":"_CardAttributeList_metaIcon__3icm4"};